import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import ProductCardSmall from '../Product/ProductCardSmall'

const Wrapper = styled.section`
  ${tw`max-w-4xl md:mx-auto mb-16`}
`

const Products = styled.div`
  ${tw`grid grid-cols-2`}
`

const Title = styled.h3`
  ${tw`border-b border-black pb-2 text-left font-extended tracking-wide mb-8`}
  font-size: 22px;
  font-weight: 500;
`

const YoutMightLike = ({ title, products }) => (
  <Wrapper>
    <Title>{title}</Title>
    <Products>
      {products?.slice(0, 4).map((product) => (
        <ProductCardSmall category="Best sellers" list="Best sellers" product={product} key={product.id} />
      ))}
    </Products>
  </Wrapper>
)

YoutMightLike.propTypes = {
  products: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
}

export default YoutMightLike
